import Bugsnag from 'lib/bugsnag'
import {
  ConsoleLogger,
  DefaultEventController,
  LogLevel,
  MeetingSessionConfiguration,
  NoOpEventReporter
} from 'amazon-chime-sdk-js'
import useCurrentUser from 'hooks/useCurrentUser'
import { useCallback } from 'react'
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react'

function useChimeMeeting(
  channelSessionId: Maybe<string>,
  channelToken: Maybe<string>
) {
  const { id: userId } = useCurrentUser()
  const meetingManager = useMeetingManager()

  const joinMeeting = useCallback(async () => {
    if (!channelSessionId || !channelToken) {
      return
    }

    const logger = new ConsoleLogger('ChimeSDK', LogLevel.WARN)
    const meetingData = JSON.parse(channelSessionId)
    const attendeeData = JSON.parse(channelToken)
    const meetingSessionConfiguration = new MeetingSessionConfiguration(
      {
        MeetingId: meetingData.meetingId,
        ExternalMeetingId: meetingData.externalMeetingId,
        MediaPlacement: {
          AudioHostUrl: meetingData.audioHostUrl,
          AudioFallbackUrl: meetingData.audioFallbackUrl,
          ScreenDataUrl: meetingData.screenDataUrl,
          ScreenSharingUrl: meetingData.screenSharingUrl,
          ScreenViewingUrl: meetingData.screenViewingUrl,
          SignalingUrl: meetingData.signalingUrl,
          TurnControlUrl: meetingData.turnControlUrl
        },
        MediaRegion: meetingData.mediaRegion
      },
      {
        ExternalUserId: `user:${userId}`,
        AttendeeId: attendeeData.attendeeId,
        JoinToken: attendeeData.joinToken
      }
    )
    const eventController = new DefaultEventController(
      meetingSessionConfiguration,
      logger,
      new NoOpEventReporter()
    )

    try {
      await meetingManager.join(meetingSessionConfiguration, {
        eventController
      })
      await meetingManager.start()
    } catch (err) {
      console.error('Something went wrong')
      Bugsnag.notify(err)
    }
  }, [channelSessionId, channelToken, userId, meetingManager])

  const leaveMeeting = meetingManager.leave

  return { joinMeeting, leaveMeeting }
}

export default useChimeMeeting
